import React from 'react'
import './ImageStyleSheet.css';

function EduFour() {
    window.scrollTo(0,0);
    return (
        <div className="container">
            <img src="/images/thsimg4.jpeg" className='img-view'/>
        </div>
    )
}

export default EduFour
